module.exports = __webpack_public_path__ + "0f4a417786af535bcd10ccb0a647c359.pdf";